module.exports = __webpack_public_path__ + "static/12-e466ca32ddfbb7871defb31c7095e397.jpg";